module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAABNElEQVR42oWQP0vEQBDFI1jb2finsNHKwkZBsRUbEcQvIGiR2Ww2M7sJXOPFQjhO/AwiNtZWIoJcoYiNH0JrFUHb+IbcQZSAC4+FmfdmfrtR8yRFMRWnXMVOXpvSmhVZiv475OSWMgm2KGZGIs43jQsrcSpvzDzdGrSdziSMG5TyS1mW481enHkLgi/juB87vkuyfI1EVm1ZTtRh5mVFJMfvaMy2LUB/z3DYBuE5fI+Uyr1mEuZFxb5E4UQ3o0mW8/U61k5qMr+fhDCnGfxPLwLWMd7dHX7ep96U+Z2/YSMyX5PKk97G+T50BAI/gJ4x6EONJOEAhm9tNgXPAwZfqUepdQgoukpwCPVGheGWgdabQu2s7nmuafniF6JzxQKecG1SOa2qaixqOSDYxaAb4rA1qv0Atdm1xDz5q4AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/c-automotive_1x.png
// module id = 2280
// module chunks = 0